import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IGenericResponse } from '../shared';
import { LoggingService } from '../shared/services/logging/logging.service';
import { ContractClass } from './store/contract-class.model';

@Injectable({
  providedIn: 'root'
})
export class ClassService {

  constructor(private http: HttpClient, private log: LoggingService) { }

  private uri = `${environment.apiLocation}/ContractClass`;

  public postContractClass(contractListID: string): Observable<Array<ContractClass>> {
    this.log.verbose({
      type: 'ClassService:postContractClass',
      uri: this.uri
    });
    return this.http
      .post<Array<ContractClass>>(this.uri,
        {
          ContractListID: contractListID
        }
      )
      .pipe(
        tap(res =>
          this.log.verbose({
            type: 'ClassService:response',
            res
          })
        )
      );
  }

  public putContractClass(
    contractClasses: Array<ContractClass>
  ): Observable<IGenericResponse<ContractClass>> {
    return this.http
      .put<IGenericResponse<ContractClass>>(this.uri, {
        ContractClassList: contractClasses
      })
      .pipe(
        tap(data =>
          this.log.verbose({
            type: 'ClassService:putContractClass',
            data
          })
        )
      );
  }
}
